module.exports = __webpack_public_path__ + "static/img/074_TO8_1703_og.7ad8cbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/074_TO8_1703_og.jpg
// module id = 4SyW
// module chunks = 0